import { Content, Header, Page, Progress, ResponseErrorPanel } from "@backstage/core-components";
import { useApi } from "@backstage/core-plugin-api";
import { catalogApiRef } from "@backstage/plugin-catalog-react";
import React from "react";
import useAsync from "react-use/esm/useAsync";
import { GetEntitiesResponse } from '@backstage/catalog-client'
import { DomainCard } from "./Card";
import { Grid, Tooltip } from "@material-ui/core";
import { SetCookieComponent } from "../catalog/SetCookie";


export const DomainsPage = () => {
    const catalogApi = useApi(catalogApiRef)
    const { value, loading, error } = useAsync(async (): Promise<GetEntitiesResponse> => {
        const response = catalogApi.getEntities({ filter: [{ kind: 'Component' }] })
        return response
    })
    if (loading) {
        <Progress />
    }
    if (error) {
        return (<ResponseErrorPanel error={error || { name: "DomainsNotFoud", message: "Unable to retrieve any domains" }}></ResponseErrorPanel>)
    }
    return (
        <Page themeId="home">
        <Header title={"MAF Retail Platform Domains"} pageTitleOverride="Home" />
        <Content>
            <SetCookieComponent />
            <Grid container spacing={3} alignItems="stretch">
                {value && value.items.map(e => {
                    const truncatedDescription = e.metadata.description?.length && e.metadata.description.length > 100
                        ? e.metadata.description.substring(0, 100) + '...'
                        : e.metadata.description || "No Description Found";

                    return (
                        <Grid item md={6} key={e.metadata.name}>
                            <Tooltip title={e.metadata.description || "No Description Found"}>
                                <div>
                                    <DomainCard
                                        name={e.metadata.name}
                                        description={truncatedDescription}
                                        kind="component"
                                    />
                                </div>
                            </Tooltip>
                        </Grid>
                    );
                })}
            </Grid>
        </Content>
    </Page>
    )
}